/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms

import io.kvision.*
import io.kvision.pace.Pace
import io.kvision.pace.PaceOptions
import io.kvision.panel.StackPanel
import io.kvision.panel.root
import io.kvision.panel.stackPanel
import io.kvision.routing.Routing
import io.kvision.routing.routing
import io.kvision.utils.perc
import pl.finn.forms.generator.formRouting
import pl.finn.forms.model.FormTemplate

class App : Application() {

  private val FORM_INDEX = 0

  private lateinit var rootStack: StackPanel

  override fun start(state: Map<String, Any>) {
    Routing.init()
    Pace.init(require("pace-progressbar/themes/blue/pace-theme-corner-indicator.css"))
    Pace.setOptions(PaceOptions(manual = true))
    root("kvapp") {
      width = 100.perc
//      add(
//        Div(className = "form-check", "form-switch", "float-right", "mt-2", "ml-auto", "w-auto")) {
//          checkBoxInput(className = "form-check-input", "toggle-theme-switch", "my-2")) {
//            id = "toggle-switch"
//          }
//          label(className = "form-check-label"), forId = "toggle-switch") { }
//        }
//      )
      rootStack = stackPanel(false) {
        add(FormTemplate())
      }
      routing.formRouting(this@App)
      routing.resolve()
    }
  }

  fun activateFormTemplate() {
    rootStack.activeIndex = FORM_INDEX
  }
}

fun main() {
  startApplication(::App, module.hot, BootstrapModule, FontAwesomeModule, CoreModule)
}
